import React from "react"
import SwitchingTreeSkeleton from "components/CustomerBehavior/Switching/SwitchingTreeSkeleton/SwitchingTreeSkeleton"
import CustomerDescriptionSkeleton from "components/Shared/CustomerDescription/CustomerDescriptionSkeleton"
import InformationTableSkeleton from "components/Shared/InformationTable/Skeleton/InformationTableSkeleton"
import { SwitchingSankeyContainerSkeleton } from "../SwitchingSankeyContainer"
import { SANKEY_SWITCHING_FLAG } from "components/CustomerBehavior/Switching/SankeySwitching/constants"
import { isFeatureEnabled } from "config/feature-flags"

const SwitchingValidateDataSkeleton = () => {
	return (
		<>
			<CustomerDescriptionSkeleton />
			<SwitchingTreeSkeleton />
			<SwitchingSankeyContainerSkeleton
				isVisible={isFeatureEnabled(SANKEY_SWITCHING_FLAG)}
			/>
			<InformationTableSkeleton />
		</>
	)
}

export default SwitchingValidateDataSkeleton
